import { FC, useMemo } from 'react';
import { Control, FieldValues, useWatch } from 'react-hook-form';
import { Box, useThemeValue } from '@altermaind/web/ui';
import { Form } from '@/_shared/components/Form';
import { convertSizeToNumber } from '@/_shared/helpers';
import { postSurveysCampaignByIdNextCall } from '@/surveys/state/api/postSurveysCampaignByIdNextCall';

type Props = {
  currentStep: ReturnType<(typeof postSurveysCampaignByIdNextCall)['hook']>['activeStep'];
  control: Control<FieldValues>;
};
export const SingleChoiceAnswer: FC<Props> = ({ currentStep, control }) => {
  const gapXS = convertSizeToNumber(`${useThemeValue('sizes', 'xs')}`) || 16;
  const value = useWatch({ control, name: currentStep.nextQuestion?.id || 'singleChoiceAnswer' });

  const random = 0.5;

  const shuffledOptions = useMemo(() => {
    const options =
      currentStep.nextQuestion?.options?.map((option, index) => ({
        label: option.text || '',
        value: option.id || '',
        index,
        selected: value === option.id,
      })) || [];
    return [...options].sort(() => Math.random() - random);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep.nextQuestion?.id]);

  return (
    <Box style={{ cursor: 'pointer' }}>
      <Form.FormRadio
        // @ts-ignore
        control={control}
        name={currentStep.nextQuestion?.id || 'singleChoiceAnswer'}
        items={shuffledOptions}
        radioItemAlign='vertical'
        wrapperProps={{
          style: { gap: gapXS },
          display: 'flex',
          mr: 'none',
        }}
        containerRadioProps={{
          px: 's',
          py: 'xs',
          bg: 'grey/dark/background',
          borderRadius: 's',
        }}
        checkedColor='white'
        containerSelectedRadioOverrideProps={{
          bg: 'primary',
        }}
        isTotalClickable
      />
    </Box>
  );
};
